import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("processingcenter") !== null && localStorage.getItem("processingcenter") !== undefined && localStorage.getItem("processingcenter") !== "") {

    data = JSON.parse(localStorage.getItem("processingcenter"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getprocessingcenter: (state, action) => {
            localStorage.setItem("processingcenter", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { seedetails, home, getprocessingcenter } = Insider.actions;
export default Insider.reducer;